module.exports = __webpack_public_path__ + "img/website.92bd33df.svg";